export const StoreConciliationDivergenceValueRange = [
  {
    value: "BETWEEN_MINUS5_PLUS5",
    label: "Entre -5 e 5",
  },
  {
    value: "BETWEEN_MINUS5_ZERO",
    label: "Entre -5 e 0",
  },
  {
    value: "BETWEEN_ZERO_PLUS5",
    label: "Entre 0 e 5",
  },
];
